module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmNzYxZTg4M2Q4OTY3NjlmYzIwOTc4Njg1OTM5Mjg4Mi5wbmciOw=="